import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Home extends Component {
	componentWillMount () {
		const { firstNavigationPath, history } = this.props;
		if (firstNavigationPath) {
			history.push(firstNavigationPath);
		}
	}

	componentWillReceiveProps (nextProps) {
		const { firstNavigationPath, history } = nextProps;

		if (firstNavigationPath) {
			history.push(firstNavigationPath);
		}
	}

	render () {
		return <div className="placeholder-wrap"><div className="placeholder"></div></div>
	}
}

Home.propTypes = {
	firstNavigationPath: PropTypes.string,
	history: PropTypes.object.isRequired
}

export default Home;



// WEBPACK FOOTER //
// ./components/Home.js